import React, { useEffect, useRef, useState } from 'react';
import { AppToastDetail, onToast } from '../utils/toast';
import '../styles/AppToastHost.css';

const AppToastHost: React.FC = () => {
  const [toast, setToast] = useState<AppToastDetail | null>(null);
  const timerRef = useRef<number | null>(null);
  const handlerRef = useRef<(detail: AppToastDetail) => void>((detail) => {
    setToast(detail);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    const duration = Number(detail.durationMs || 4200);
    timerRef.current = window.setTimeout(() => setToast(null), Math.max(1200, duration));
  });

  useEffect(() => {
    // Use the stable ref so removeEventListener can match the exact listener.
    const unsubscribe = onToast((detail) => handlerRef.current(detail));

    return () => {
      unsubscribe();
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  if (!toast) return null;

  return (
    <div className={`global-toast global-toast-${toast.tone}`}>
      {toast.message}
    </div>
  );
};

export default AppToastHost;
